<template>
  <ArchitectProjectSummaryInfo/>
</template>

<script setup>
  import ArchitectProjectSummaryInfo from "@/components/architect/ArchitectProjectSummaryInfo.vue";
</script>
